var PluginType;
(function(PluginType2) {
  PluginType2["BEFORE"] = "before";
  PluginType2["ENRICHMENT"] = "enrichment";
  PluginType2["DESTINATION"] = "destination";
})(PluginType || (PluginType = {}));
export {
  PluginType
};
//# sourceMappingURL=plugin.js.map
